const RADIANS = Math.PI / 180;

export {

    RADIANS
};
